<h3 class="text-center">Device Sync</h3>
<div class="table-responsive" *ngIf="!loading">
<table datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Date Created </th>
    <th>Names</th>
    <th>Email</th>

    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let sync of syncs;">
        <td>{{sync.datecreated}}</td>
        <td> <a [routerLink]="['/admin/device/sync/show',sync.id]">{{sync.names}}</a></td>
        <td>{{sync.email}}</td>

    </tr>
    </tbody>
</table>
<div *ngIf="isEmpty" class="alert alert-info"> No items found</div>
</div>
<span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>


